var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.803 13.2095L28.8029 13.2095L28.804 13.2209C28.9998 15.1785 29.0984 17.932 29.0984 20C29.0984 22.068 28.9998 24.8215 28.804 26.7791L28.8033 26.7862L28.8028 26.7933C28.7227 27.9149 27.847 28.7202 26.7953 28.8041C26.287 28.8295 25.7306 28.8612 25.1496 28.8943C23.4473 28.9911 21.5337 29.1 19.9984 29.1C17.9304 29.1 15.1769 29.0014 13.2193 28.8056L13.2123 28.8049L13.2052 28.8044C12.0835 28.7243 11.2782 27.8486 11.1944 26.7969C11.1689 26.2886 11.1373 25.7322 11.1042 25.1512C11.0073 23.4489 10.8984 21.5353 10.8984 20C10.8984 17.9359 10.9967 15.1887 11.1918 13.2318C11.2746 12.6667 11.5133 12.2563 11.8775 11.801C12.1776 11.4259 12.6273 11.1969 13.1696 11.1969H13.1945L13.2193 11.1945C15.1769 10.9987 17.9304 10.9 19.9984 10.9C22.0664 10.9 24.8199 10.9987 26.7775 11.1945L26.7846 11.1952L26.7917 11.1957C27.9156 11.2759 28.7219 12.1549 28.803 13.2095Z",
    fill: "url(#paint0_linear_1528_18451)",
    stroke: "url(#paint1_linear_1528_18451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3627 17.3817L18.992 22.6181L17.3809 21.0487",
    stroke: "url(#paint2_linear_1528_18451)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1528_18451",
    x1: 19.9984,
    y1: 10.4,
    x2: 19.9984,
    y2: 29.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1528_18451",
    x1: 19.9984,
    y1: 10.4,
    x2: 19.9984,
    y2: 29.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1528_18451",
    x1: 20.8718,
    y1: 17.3817,
    x2: 20.8718,
    y2: 22.6181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.eb8dd069112c17f504025997673bfba5.svg";
export { ForwardRef as ReactComponent };